// extracted by mini-css-extract-plugin
export default {"TextTruncateComponent":"TextTruncateComponent-module__TextTruncateComponent__vISk3"};